/* tslint:disable */
/* eslint-disable */
/**
 * leverup Service Application
 * Documentation for your application APIs v1.0
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  PagedTradeHistoryResponse,
} from '../models/index';

export interface GetHistoryRequest {
    userAddress: string;
    blockChain: GetHistoryBlockChainEnum;
    page?: number;
    size?: number;
}

/**
 * 
 */
export class TradeHistoryControllerApi extends runtime.BaseAPI {

    /**
     */
    async getHistoryRaw(requestParameters: GetHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PagedTradeHistoryResponse>> {
        if (requestParameters['userAddress'] == null) {
            throw new runtime.RequiredError(
                'userAddress',
                'Required parameter "userAddress" was null or undefined when calling getHistory().'
            );
        }

        if (requestParameters['blockChain'] == null) {
            throw new runtime.RequiredError(
                'blockChain',
                'Required parameter "blockChain" was null or undefined when calling getHistory().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['blockChain'] != null) {
            queryParameters['block_chain'] = requestParameters['blockChain'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/user/{user_address}/trade/history`.replace(`{${"user_address"}}`, encodeURIComponent(String(requestParameters['userAddress']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getHistory(requestParameters: GetHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PagedTradeHistoryResponse> {
        const response = await this.getHistoryRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
  * @export
  * @enum {string}
  */
export enum GetHistoryBlockChainEnum {
    Monad = 'MONAD'
}
